export default "__VITE_ASSET__aV9u6jHQ__"